(function() {
  'use strict';

  if (window.__suitsAndMoreStyleFinder) {
    window.__suitsAndMoreStyleFinder.initialize(document);
    return;
  }

  var initialized = new WeakSet();
  var RESULT_BATCH_SIZE = 20;
  var RESULT_COUNT_CONCURRENCY = 4;
  var RESULT_PREFETCH_VIEWPORTS = 1;
  var SIZE_PREFETCH_CONCURRENCY = 2;
  var INITIAL_PROGRESS_DURATION = 2500;
  var INITIAL_PROGRESS_COMPLETE_DELAY = 160;

  function publish(eventName, payload) {
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      var result = Shopify.analytics.publish(eventName, payload);
      if (result && typeof result.catch === 'function') result.catch(function() {});
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload));
  }

  function previewParams(url) {
    ['preview_theme_id', '_fd', 'pb'].forEach(function(key) {
      var value = new URLSearchParams(window.location.search).get(key);
      if (value) url.searchParams.set(key, value);
    });
    return url;
  }

  function collectionUrl(path) {
    return previewParams(new URL(path, window.location.origin));
  }

  function sizeCollectionUrl(path) {
    var url = collectionUrl(path);
    url.hash = '';
    url.searchParams.set('filter.v.availability', '1');
    url.searchParams.sort();
    return url;
  }

  function textFrom(node) {
    return node ? node.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function walkingSizeFamily(value) {
    var compact = normalizedSize(value).replace(/[\s-]/g, '');
    var match = compact.match(/^(XSMALL|SMALL|MEDIUM|LARGE|XLARGE|([2-6])X(?:LARGE|L)?)(?=$|\/|\(|SHIRT|PANTS)/);
    if (!match) return '';

    if (match[1] === 'XSMALL') return 'X-SMALL';
    if (match[1] === 'SMALL') return 'SMALL';
    if (match[1] === 'MEDIUM') return 'MEDIUM';
    if (match[1] === 'LARGE') return 'LARGE';
    if (match[1] === 'XLARGE') return 'X-LARGE';
    return match[2] + 'X-LARGE';
  }

  function uniqueSizes(doc, mode) {
    var values = [];
    var seen = new Set();

    doc.querySelectorAll('input[name="filter.v.option.size"]').forEach(function(input) {
      if (input.disabled) return;
      var label = input.closest('label');
      var text = textFrom(label && label.querySelector('.filter-group__item__text'));
      var key = input.name + '|' + input.value;
      if (!text || seen.has(key)) return;
      seen.add(key);
      values.push({ label: text, name: input.name, value: input.value });
    });

    if (mode === 'walking') {
      var walkingFamilies = new Map();
      var walkingOrder = ['X-SMALL', 'SMALL', 'MEDIUM', 'LARGE', 'X-LARGE', '2X-LARGE', '3X-LARGE', '4X-LARGE', '5X-LARGE', '6X-LARGE'];

      values.forEach(function(item) {
        var family = walkingSizeFamily(item.label);
        if (!family) return;

        if (!walkingFamilies.has(family)) {
          walkingFamilies.set(family, {
            label: family,
            name: item.name,
            value: item.value,
            values: []
          });
        }

        var group = walkingFamilies.get(family);
        if (!group.values.includes(item.value)) group.values.push(item.value);
      });

      var walkingSizes = Array.from(walkingFamilies.values()).sort(function(a, b) {
        return walkingOrder.indexOf(a.label) - walkingOrder.indexOf(b.label);
      });
      if (walkingSizes.length) return walkingSizes;
    }

    if (mode === 'apparel') {
      var apparel = values.filter(function(item) {
        return !item.label.includes('/') &&
          !item.label.toUpperCase().includes('PANTS') &&
          /^(?:X-?SMALL|SMALL|MEDIUM|LARGE|X-?LARGE|[2-6]X[- ]?\s*LARGE)$/i.test(item.label);
      });
      if (apparel.length) return apparel;
    }

    if (mode === 'suit') {
      var suitFamilies = new Map();

      values.forEach(function(item) {
        var match = normalizedSize(item.label).match(/^(\d{2})(?=$|[\s/-])/);
        if (!match) return;

        var family = match[1];
        if (!suitFamilies.has(family)) {
          suitFamilies.set(family, {
            label: family,
            name: item.name,
            value: item.value,
            values: []
          });
        }

        var group = suitFamilies.get(family);
        if (!group.values.includes(item.value)) group.values.push(item.value);
      });

      var suits = Array.from(suitFamilies.values()).sort(function(a, b) {
        return Number(a.label) - Number(b.label);
      });
      if (suits.length) return suits;
    }

    if (mode === 'shoe') {
      var shoes = values.filter(function(item) {
        return /^\d+(?:\s+1\/2)?$/.test(normalizedSize(item.label));
      }).sort(function(a, b) {
        function shoeSizeNumber(item) {
          var match = normalizedSize(item.label).match(/^(\d+)(?:\s+(1\/2))?$/);
          return Number(match[1]) + (match[2] ? 0.5 : 0);
        }

        return shoeSizeNumber(a) - shoeSizeNumber(b);
      });
      if (shoes.length) return shoes;
    }

    return values.slice(0, 24);
  }

  function fetchDocument(url) {
    return fetch(url.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function(response) {
      if (!response.ok) throw new Error('Collection request failed');
      return response.text();
    }).then(function(html) {
      return new DOMParser().parseFromString(html, 'text/html');
    });
  }

  function collectionCards(doc) {
    return Array.from(doc.querySelectorAll('.filters-adjacent.collection-listing .product-grid product-block'));
  }

  function collectionTotalCount(doc) {
    var listing = doc.querySelector('.filters-adjacent.collection-listing[data-style-finder-total-count]');
    var value = listing && listing.getAttribute('data-style-finder-total-count');
    if (!/^\d+$/.test(value || '')) return null;

    var count = Number(value);
    return Number.isSafeInteger(count) ? count : null;
  }

  function nextCollectionUrl(doc) {
    var next = doc.querySelector('link[rel="next"], a[rel="next"]');
    return next ? collectionUrl(next.getAttribute('href')).toString() : '';
  }

  function productJsonUrl(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;

    var url = new URL(link.href, window.location.origin);
    url.pathname = url.pathname.replace(/\/$/, '') + '.js';
    url.search = '';
    url.hash = '';
    return previewParams(url);
  }

  function resultCountUrl(url, page) {
    var countUrl = new URL(url, window.location.origin);
    countUrl.searchParams.set('view', 'style-finder-count');
    if (page > 1) {
      countUrl.searchParams.set('page', String(page));
    } else {
      countUrl.searchParams.delete('page');
    }
    return countUrl;
  }

  function productCardKey(card) {
    var productId = card.getAttribute('data-product-id');
    var productLink = card.querySelector('a[href*="/products/"]');
    return productId || (productLink && productLink.href) || '';
  }

  function normalizedSize(value) {
    return String(value || '')
      .replace(/[–—]/g, '-')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();
  }

  function sizeValueMatches(value, size, mode) {
    var variantSize = normalizedSize(value);
    var selectedSize = normalizedSize(size.label || size.value);
    if (!variantSize || !selectedSize) return false;
    if (variantSize === selectedSize) return true;
    if (mode === 'hat' || mode === 'apparel') {
      var variantFamily = walkingSizeFamily(variantSize);
      return Boolean(variantFamily) && variantFamily === walkingSizeFamily(selectedSize);
    }
    if (mode !== 'suit') return false;
    if (variantSize.indexOf(selectedSize) !== 0) return false;
    return /^[\s/-]/.test(variantSize.slice(selectedSize.length));
  }

  function productHasAvailableSize(product, size, mode) {
    var options = product && Array.isArray(product.options) ? product.options : [];
    var sizeIndex = options.findIndex(function(option) {
      var name = typeof option === 'string' ? option : option && option.name;
      return String(name || '').toLowerCase() === 'size';
    });
    if (sizeIndex < 0 || !Array.isArray(product.variants)) return false;

    return product.variants.some(function(variant) {
      var values = Array.isArray(variant.options) ? variant.options : [];
      return variant.available === true && sizeValueMatches(values[sizeIndex], size, mode);
    });
  }

  function Finder(root) {
    this.root = root;
    this.id = root.getAttribute('data-section-id');
    this.step = 1;
    this.categoryId = '';
    this.category = '';
    this.occasion = '';
    this.destination = '';
    this.sizeMode = 'all';
    this.size = null;
    this.started = false;
    this.baseDocument = null;
    this.requestToken = 0;
    this.sizeDocumentCache = new Map();
    this.sizeDocumentRequests = new Map();
    this.sizeDocumentQueue = [];
    this.sizeDocumentQueueEntries = new Map();
    this.activeSizeDocumentRequests = 0;
    this.productRequests = new Map();
    this.resultDocumentRequests = new Map();
    this.resultCountRequests = new Map();
    this.pendingResultCards = [];
    this.resultProductIds = new Set();
    this.requestedResultPageUrls = new Set();
    this.nextResultPageUrl = '';
    this.resultTotalCount = null;
    this.resultsLoading = false;
    this.resultsObserver = null;
    this.initialProgressFrame = null;
    this.initialProgressHideTimer = null;
    this.initialProgressToken = null;

    this.panels = Array.from(root.querySelectorAll('[data-style-step]'));
    this.progress = Array.from(root.querySelectorAll('[data-style-progress]'));
    this.categoryPanels = Array.from(root.querySelectorAll('[data-style-category-panel]'));
    this.sizeOptions = root.querySelector('[data-style-size-options]');
    this.status = root.querySelector('[data-style-status]');
    this.controls = root.querySelector('[data-style-controls]');
    this.backButton = root.querySelector('[data-style-back]');
    this.resultsGrid = root.querySelector('[data-style-results-grid]');
    this.resultsSummary = root.querySelector('[data-style-results-summary]');
    this.resultsNotice = root.querySelector('[data-style-results-notice]');
    this.resultsPanel = root.querySelector('[data-style-step="4"]');
    this.initialProgress = root.querySelector('[data-style-initial-progress]');
    this.initialProgressBar = root.querySelector('[data-style-initial-progress-bar]');
    this.resultsLoader = root.querySelector('[data-style-results-loader]');
    this.resultsSentinel = root.querySelector('[data-style-results-sentinel]');
    this.bind();
    this.replaceHistory();
    this.render(false);
  }

  Finder.prototype.historyState = function() {
    return {
      id: this.id,
      step: this.step,
      categoryId: this.categoryId,
      category: this.category,
      occasion: this.occasion,
      destination: this.destination,
      sizeMode: this.sizeMode,
      size: this.size ? {
        name: this.size.name,
        value: this.size.value,
        values: this.size.values,
        label: this.size.label
      } : null
    };
  };

  Finder.prototype.replaceHistory = function() {
    var current = Object.assign({}, window.history.state || {});
    current.samStyleFinder = this.historyState();
    window.history.replaceState(current, '', window.location.href);
  };

  Finder.prototype.pushHistory = function() {
    var current = Object.assign({}, window.history.state || {});
    current.samStyleFinder = this.historyState();
    var hash = '#style-finder-' + this.id + '-step-' + this.step;
    window.history.pushState(current, '', hash);
  };

  Finder.prototype.bind = function() {
    var self = this;

    this.root.addEventListener('click', function(event) {
      var categoryButton = event.target.closest('[data-style-category]');
      if (categoryButton && self.root.contains(categoryButton)) {
        self.selectCategory(categoryButton);
        return;
      }

      var occasionButton = event.target.closest('[data-style-occasion]');
      if (occasionButton && self.root.contains(occasionButton)) {
        self.selectOccasion(occasionButton);
        return;
      }

      var sizeButton = event.target.closest('[data-style-size]');
      if (sizeButton && self.root.contains(sizeButton)) {
        self.selectSize(sizeButton);
        return;
      }

      var restartButton = event.target.closest('[data-style-restart]');
      if (restartButton && self.root.contains(restartButton)) {
        self.restart(true);
        return;
      }

      var productLink = event.target.closest('[data-style-results-grid] a[href*="/products/"]');
      if (productLink && self.root.contains(productLink)) {
        var card = productLink.closest('[data-product-id]');
        var cards = Array.from(self.resultsGrid.querySelectorAll('[data-product-id]'));
        publish('style_finder_product_click', {
          category: self.category,
          occasion: self.occasion,
          result_count: cards.length,
          product_id: card && card.getAttribute('data-product-id'),
          position: card ? cards.indexOf(card) + 1 : null
        });
      }
    });

    this.backButton.addEventListener('click', function() {
      window.history.back();
    });

    window.addEventListener('popstate', function(event) {
      var state = event.state && event.state.samStyleFinder;
      if (!state || state.id !== self.id) {
        self.restart(false);
        return;
      }
      self.restore(state);
    });

    function prioritizeOccasion(event) {
      var occasionButton = event.target.closest('[data-style-occasion]');
      if (occasionButton && self.root.contains(occasionButton)) {
        self.prefetchOccasion(occasionButton, true);
      }
    }

    this.root.addEventListener('pointerover', prioritizeOccasion);
    this.root.addEventListener('focusin', prioritizeOccasion);
    this.root.addEventListener('touchstart', prioritizeOccasion, { passive: true });
  };

  Finder.prototype.start = function() {
    if (this.started) return;
    this.started = true;
    publish('style_finder_start', {});
  };

  Finder.prototype.answer = function(step, answer) {
    publish('style_finder_answer', {
      step: step,
      answer: answer,
      category: this.category || null,
      occasion: this.occasion || null
    });
  };

  Finder.prototype.selectCategory = function(button) {
    this.start();
    this.categoryId = button.getAttribute('data-category-id');
    this.category = button.getAttribute('data-category-label');
    this.sizeMode = button.getAttribute('data-size-mode') || 'all';
    this.occasion = '';
    this.destination = '';
    this.size = null;
    this.baseDocument = null;
    this.step = 2;
    this.answer('category', this.category);
    this.pushHistory();
    this.render(true);
  };

  Finder.prototype.selectOccasion = function(button) {
    this.occasion = button.getAttribute('data-occasion-label');
    this.destination = button.getAttribute('data-collection-url');
    this.size = null;
    this.step = 3;
    this.answer('occasion', this.occasion);
    this.pushHistory();
    this.render(true);
    this.loadSizes();
  };

  Finder.prototype.promoteSizeDocumentRequest = function(key) {
    var entry = this.sizeDocumentQueueEntries.get(key);
    if (!entry || entry.started) return;

    var index = this.sizeDocumentQueue.indexOf(entry);
    if (index < 1) return;
    this.sizeDocumentQueue.splice(index, 1);
    this.sizeDocumentQueue.unshift(entry);
  };

  Finder.prototype.drainSizeDocumentQueue = function() {
    var self = this;

    function start(entry) {
      entry.started = true;
      self.activeSizeDocumentRequests++;

      fetchDocument(entry.url).then(function(doc) {
        self.sizeDocumentCache.set(entry.key, doc);
        self.sizeDocumentRequests.delete(entry.key);
        self.sizeDocumentQueueEntries.delete(entry.key);
        entry.resolve(doc);
      }, function(error) {
        self.sizeDocumentRequests.delete(entry.key);
        self.sizeDocumentQueueEntries.delete(entry.key);
        entry.reject(error);
      }).then(function() {
        self.activeSizeDocumentRequests--;
        self.drainSizeDocumentQueue();
      });
    }

    while (
      this.activeSizeDocumentRequests < SIZE_PREFETCH_CONCURRENCY &&
      this.sizeDocumentQueue.length
    ) {
      start(this.sizeDocumentQueue.shift());
    }
  };

  Finder.prototype.requestSizeDocument = function(destination, priority) {
    var url = sizeCollectionUrl(destination);
    var key = url.toString();
    if (this.sizeDocumentCache.has(key)) {
      return Promise.resolve(this.sizeDocumentCache.get(key));
    }

    if (this.sizeDocumentRequests.has(key)) {
      if (priority) this.promoteSizeDocumentRequest(key);
      return this.sizeDocumentRequests.get(key);
    }

    var entry = {
      key: key,
      url: url,
      started: false,
      resolve: null,
      reject: null
    };
    var request = new Promise(function(resolve, reject) {
      entry.resolve = resolve;
      entry.reject = reject;
    });

    this.sizeDocumentRequests.set(key, request);
    this.sizeDocumentQueueEntries.set(key, entry);
    if (priority) {
      this.sizeDocumentQueue.unshift(entry);
    } else {
      this.sizeDocumentQueue.push(entry);
    }
    this.drainSizeDocumentQueue();
    return request;
  };

  Finder.prototype.prefetchOccasion = function(button, priority) {
    var destination = button && button.getAttribute('data-collection-url');
    if (!destination) return;
    this.requestSizeDocument(destination, priority).catch(function() {});
  };

  Finder.prototype.prefetchVisibleOccasions = function() {
    var self = this;

    this.categoryPanels.forEach(function(panel) {
      if (panel.hidden) return;
      panel.querySelectorAll('[data-style-occasion]').forEach(function(button) {
        self.prefetchOccasion(button, false);
      });
    });
  };

  Finder.prototype.loadSizes = function() {
    var self = this;
    var token = ++this.requestToken;
    this.sizeOptions.innerHTML = '';
    this.status.textContent = this.root.getAttribute('data-size-loading-text');

    this.requestSizeDocument(this.destination, true).then(function(doc) {
      if (token !== self.requestToken) return;
      self.baseDocument = doc;
      var sizes = uniqueSizes(doc, self.sizeMode);

      sizes.forEach(function(size) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'style-finder__option';
        button.setAttribute('data-style-size', '');
        button.setAttribute('data-size-name', size.name);
        button.setAttribute('data-size-value', size.value);
        button.setAttribute('data-size-values', JSON.stringify(size.values || [size.value]));
        button.setAttribute('data-size-label', size.label);
        button.innerHTML = '<span class="style-finder__option-title"></span>';
        button.querySelector('span').textContent = size.label;
        self.sizeOptions.appendChild(button);
      });

      var unsure = document.createElement('button');
      unsure.type = 'button';
      unsure.className = 'style-finder__option';
      unsure.setAttribute('data-style-size', '');
      unsure.setAttribute('data-size-unsure', 'true');
      unsure.innerHTML = '<span class="style-finder__option-title"></span>';
      unsure.querySelector('span').textContent = self.root.getAttribute('data-not-sure-label');
      self.sizeOptions.appendChild(unsure);

      self.status.textContent = '';
    }).catch(function() {
      if (token !== self.requestToken) return;
      self.showRequestError();
    });
  };

  Finder.prototype.selectSize = function(button) {
    var unsure = button.getAttribute('data-size-unsure') === 'true';
    var value = button.getAttribute('data-size-value');
    var values = [];
    try {
      values = JSON.parse(button.getAttribute('data-size-values') || '[]');
    } catch (error) {
      values = [];
    }
    if (!Array.isArray(values) || !values.length) values = value ? [value] : [];

    this.size = unsure ? null : {
      name: button.getAttribute('data-size-name'),
      value: value,
      values: values,
      label: button.getAttribute('data-size-label')
    };
    this.answer('size', unsure ? 'not_sure' : 'size_selected');
    this.showResults();
  };

  Finder.prototype.fetchProduct = function(card) {
    var self = this;
    var url = productJsonUrl(card);
    if (!url) return Promise.reject(new Error('Product URL missing'));

    var key = url.toString();
    if (this.productRequests.has(key)) return this.productRequests.get(key);

    var request = fetch(key, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function(response) {
      if (!response.ok) throw new Error('Product request failed');
      return response.json();
    }).catch(function(error) {
      self.productRequests.delete(key);
      throw error;
    });

    this.productRequests.set(key, request);
    return request;
  };

  Finder.prototype.fetchResultDocument = function(url) {
    var self = this;
    var requestUrl = new URL(url, window.location.origin);
    var key = requestUrl.toString();
    if (this.resultDocumentRequests.has(key)) return this.resultDocumentRequests.get(key);

    var request = fetchDocument(requestUrl).catch(function(error) {
      self.resultDocumentRequests.delete(key);
      throw error;
    });

    this.resultDocumentRequests.set(key, request);
    return request;
  };

  Finder.prototype.fetchResultCountPage = function(url) {
    var self = this;
    var key = url.toString();
    if (this.resultCountRequests.has(key)) return this.resultCountRequests.get(key);

    var request = fetch(key, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function(response) {
      if (!response.ok) throw new Error('Result count request failed');
      return response.json();
    }).then(function(data) {
      if (!data || !Array.isArray(data.matched_product_ids)) {
        throw new Error('Result count response invalid');
      }
      return data;
    }).catch(function(error) {
      self.resultCountRequests.delete(key);
      throw error;
    });

    this.resultCountRequests.set(key, request);
    return request;
  };

  Finder.prototype.availableCardsForSize = function(cards, limit, token) {
    var self = this;
    var available = [];
    var batchSize = 4;

    function verifyBatch(index) {
      if (token !== undefined && token !== self.requestToken) {
        return Promise.resolve(null);
      }
      if (available.length >= limit || index >= cards.length) {
        return Promise.resolve(available.slice(0, limit));
      }

      var batch = cards.slice(index, index + batchSize);
      return Promise.all(batch.map(function(card) {
        return self.fetchProduct(card).then(function(product) {
          return productHasAvailableSize(product, self.size, self.sizeMode);
        });
      })).then(function(matches) {
        if (token !== undefined && token !== self.requestToken) return null;
        batch.forEach(function(card, batchIndex) {
          if (matches[batchIndex]) available.push(card);
        });
        return verifyBatch(index + batchSize);
      });
    }

    return verifyBatch(0);
  };

  Finder.prototype.initialVerifiedResultBatch = function(doc, token) {
    var self = this;
    var cards = [];
    var requestedPageUrls = new Set();

    function collect(currentDocument) {
      var pageCards = collectionCards(currentDocument);
      var nextPageUrl = nextCollectionUrl(currentDocument);

      return self.availableCardsForSize(pageCards, pageCards.length, token).then(function(matches) {
        if (!matches || token !== self.requestToken) return null;
        cards = cards.concat(matches);

        if (cards.length >= RESULT_BATCH_SIZE || !nextPageUrl) {
          return { cards: cards, nextPageUrl: nextPageUrl };
        }

        if (requestedPageUrls.has(nextPageUrl)) {
          return { cards: cards, nextPageUrl: '' };
        }
        requestedPageUrls.add(nextPageUrl);
        return self.fetchResultDocument(nextPageUrl).then(collect);
      });
    }

    return collect(doc);
  };

  Finder.prototype.verifiedResultCount = function(url, token) {
    var self = this;
    var productIds = new Set();

    function addProductIds(data) {
      data.matched_product_ids.forEach(function(productId) {
        productIds.add(String(productId));
      });
    }

    return this.fetchResultCountPage(resultCountUrl(url, 1)).then(function(firstPage) {
      if (token !== self.requestToken) return null;
      var totalPages = Number(firstPage.pages);
      if (!Number.isSafeInteger(totalPages) || totalPages < 1) {
        throw new Error('Result count page total invalid');
      }

      addProductIds(firstPage);
      var nextPage = 2;

      function worker() {
        if (token !== self.requestToken || nextPage > totalPages) {
          return Promise.resolve();
        }

        var page = nextPage++;
        return self.fetchResultCountPage(resultCountUrl(url, page)).then(function(data) {
          if (token !== self.requestToken) return;
          addProductIds(data);
          return worker();
        });
      }

      var workerCount = Math.min(RESULT_COUNT_CONCURRENCY, totalPages - 1);
      var workers = [];
      for (var index = 0; index < workerCount; index++) workers.push(worker());

      return Promise.all(workers).then(function() {
        return token === self.requestToken ? productIds.size : null;
      });
    });
  };

  Finder.prototype.disconnectResultsObserver = function() {
    if (this.resultsObserver) this.resultsObserver.disconnect();
    this.resultsObserver = null;
  };

  Finder.prototype.setInitialProgressValue = function(value) {
    if (!this.initialProgress || !this.initialProgressBar) return;
    var normalized = Math.min(100, Math.max(0, Math.round(value)));
    this.initialProgress.setAttribute('aria-valuenow', String(normalized));
    this.initialProgressBar.style.transform = 'scaleX(' + (normalized / 100) + ')';
  };

  Finder.prototype.resetInitialProgress = function() {
    if (this.initialProgressFrame !== null) {
      window.cancelAnimationFrame(this.initialProgressFrame);
      this.initialProgressFrame = null;
    }
    if (this.initialProgressHideTimer !== null) {
      window.clearTimeout(this.initialProgressHideTimer);
      this.initialProgressHideTimer = null;
    }
    this.initialProgressToken = null;
    if (this.resultsPanel) this.resultsPanel.setAttribute('aria-busy', 'false');
    if (this.initialProgress) this.initialProgress.hidden = true;
    this.setInitialProgressValue(0);
  };

  Finder.prototype.startInitialProgress = function(token) {
    var self = this;
    this.resetInitialProgress();
    if (!this.initialProgress || !this.initialProgressBar) return;

    this.initialProgressToken = token;
    this.initialProgress.hidden = false;
    if (this.resultsPanel) this.resultsPanel.setAttribute('aria-busy', 'true');

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.setInitialProgressValue(90);
      return;
    }

    var startedAt = window.performance.now();
    function updateProgress(timestamp) {
      if (self.initialProgressToken !== token) return;
      var elapsed = Math.max(0, timestamp - startedAt);
      var ratio = Math.min(1, elapsed / INITIAL_PROGRESS_DURATION);
      self.setInitialProgressValue(ratio * 90);
      if (ratio < 1) {
        self.initialProgressFrame = window.requestAnimationFrame(updateProgress);
      } else {
        self.initialProgressFrame = null;
      }
    }

    this.initialProgressFrame = window.requestAnimationFrame(updateProgress);
  };

  Finder.prototype.completeInitialProgress = function(token) {
    if (this.initialProgressToken !== token) return;
    if (this.initialProgressFrame !== null) {
      window.cancelAnimationFrame(this.initialProgressFrame);
      this.initialProgressFrame = null;
    }

    var self = this;
    this.setInitialProgressValue(100);
    if (this.resultsPanel) this.resultsPanel.setAttribute('aria-busy', 'false');
    this.initialProgressHideTimer = window.setTimeout(function() {
      if (self.initialProgressToken !== token) return;
      self.initialProgress.hidden = true;
      self.initialProgressToken = null;
      self.initialProgressHideTimer = null;
      self.setInitialProgressValue(0);
    }, INITIAL_PROGRESS_COMPLETE_DELAY);
  };

  Finder.prototype.resetProgressiveResults = function() {
    this.disconnectResultsObserver();
    this.pendingResultCards = [];
    this.resultProductIds = new Set();
    this.requestedResultPageUrls = new Set();
    this.nextResultPageUrl = '';
    this.resultTotalCount = null;
    this.verifyProgressiveResultSize = false;
    this.resultsLoading = false;
    this.resultsLoader.hidden = true;
  };

  Finder.prototype.queueResultCards = function(cards) {
    var self = this;

    cards.forEach(function(card) {
      var key = productCardKey(card);
      if (key && self.resultProductIds.has(key)) return;
      if (key) self.resultProductIds.add(key);
      self.pendingResultCards.push(card);
    });
  };

  Finder.prototype.appendResultCards = function(limit) {
    var self = this;
    var sources = this.pendingResultCards.splice(0, limit);

    sources.forEach(function(source) {
      var card = source.cloneNode(true);
      card.querySelectorAll('[data-cc-animate]').forEach(function(node) {
        node.removeAttribute('data-cc-animate');
        node.removeAttribute('data-cc-animate-delay');
        node.removeAttribute('style');
      });
      card.querySelectorAll('.quickbuy-toggle').forEach(function(node) {
        node.classList.remove('quickbuy-toggle');
      });
      self.resultsGrid.appendChild(card);
    });

    this.updateResultsSummary();
  };

  Finder.prototype.updateResultsSummary = function() {
    var visibleCount = this.resultsGrid.querySelectorAll('[data-product-id]').length;
    var displayedCount = this.resultTotalCount === null ?
      String(visibleCount) :
      visibleCount + ' of ' + this.resultTotalCount;
    var countTemplate = this.root.getAttribute('data-result-count-template');
    this.resultsSummary.textContent = countTemplate
      .replace('[visible]', String(visibleCount))
      .replace('[count]', displayedCount);
  };

  Finder.prototype.hasProgressiveResults = function() {
    return this.pendingResultCards.length > 0 || Boolean(this.nextResultPageUrl);
  };

  Finder.prototype.observeProgressiveResults = function() {
    var self = this;

    this.disconnectResultsObserver();
    if (!this.hasProgressiveResults()) return;

    if (!('IntersectionObserver' in window)) {
      this.loadNextResultBatch();
      return;
    }

    this.resultsObserver = new IntersectionObserver(function(entries) {
      if (entries.some(function(entry) { return entry.isIntersecting; })) {
        self.loadNextResultBatch();
      }
    }, { rootMargin: (window.innerHeight * RESULT_PREFETCH_VIEWPORTS) + 'px 0px' });
    this.resultsObserver.observe(this.resultsSentinel);
  };

  Finder.prototype.loadNextResultBatch = function() {
    if (this.resultsLoading || !this.hasProgressiveResults()) return;

    var self = this;
    var token = this.requestToken;
    this.resultsLoading = true;
    this.resultsLoader.hidden = false;

    function fillBatch() {
      if (self.pendingResultCards.length >= RESULT_BATCH_SIZE || !self.nextResultPageUrl) {
        return Promise.resolve();
      }

      var nextUrl = self.nextResultPageUrl;
      self.nextResultPageUrl = '';
      if (self.requestedResultPageUrls.has(nextUrl)) return Promise.resolve();
      self.requestedResultPageUrls.add(nextUrl);
      return self.fetchResultDocument(nextUrl).then(function(doc) {
        if (token !== self.requestToken) return;
        self.nextResultPageUrl = nextCollectionUrl(doc);
        var cards = collectionCards(doc);
        var eligibleCards = self.verifyProgressiveResultSize ?
          self.availableCardsForSize(cards, cards.length, token) :
          Promise.resolve(cards);

        return eligibleCards.then(function(matches) {
          if (!matches || token !== self.requestToken) return;
          self.queueResultCards(matches);
          return fillBatch();
        });
      });
    }

    fillBatch().then(function() {
      if (token !== self.requestToken) return;
      self.appendResultCards(RESULT_BATCH_SIZE);
      self.resultsLoading = false;
      self.resultsLoader.hidden = true;

      if (!self.hasProgressiveResults()) {
        self.disconnectResultsObserver();
      } else if (!('IntersectionObserver' in window)) {
        self.loadNextResultBatch();
      }
    }).catch(function() {
      if (token !== self.requestToken) return;
      self.resultsLoading = false;
      self.nextResultPageUrl = '';
      self.resultsLoader.hidden = true;
      self.disconnectResultsObserver();
      self.status.textContent = self.root.getAttribute('data-error-message');
    });
  };

  Finder.prototype.clearResults = function() {
    this.resetInitialProgress();
    this.resetProgressiveResults();
    this.resultsGrid.innerHTML = '';
    this.resultsSummary.textContent = '';
    this.resultsNotice.hidden = true;
    this.resultsNotice.textContent = '';
    this.status.textContent = '';
  };

  Finder.prototype.showResults = function(options) {
    options = options || {};
    var self = this;
    var token = ++this.requestToken;
    var limit = Number(this.root.getAttribute('data-results-limit')) || 8;
    var baseUrl = collectionUrl(this.destination);
    baseUrl.searchParams.set('filter.v.availability', '1');
    var resultUrl = new URL(baseUrl.toString());

    if (this.size) {
      var selectedValues = Array.isArray(this.size.values) && this.size.values.length ?
        this.size.values :
        [this.size.value];
      selectedValues.forEach(function(value) {
        resultUrl.searchParams.append(self.size.name, value);
      });
    }

    this.step = 4;
    if (options.pushHistory !== false) this.pushHistory();
    this.render(true);
    this.clearResults();
    this.resultDocumentRequests.clear();
    this.resultCountRequests.clear();
    this.status.textContent = this.root.getAttribute('data-results-loading-text');
    this.startInitialProgress(token);
    var verifiedCountRequest =
      (
        this.sizeMode === 'suit' ||
        this.sizeMode === 'hat' ||
        this.sizeMode === 'apparel' ||
        this.sizeMode === 'shoe'
      ) && this.size ?
        this.verifiedResultCount(resultUrl, token).catch(function() { return null; }) :
        null;
    var firstRequest = this.size ? this.fetchResultDocument(resultUrl) : Promise.resolve(this.baseDocument);
    firstRequest.then(function(doc) {
      if (token !== self.requestToken) return;
      if (!doc) return self.fetchResultDocument(resultUrl);
      return doc;
    }).then(function(doc) {
      if (token !== self.requestToken || !doc) return;
      var cards = collectionCards(doc);

      if (self.sizeMode === 'walking') {
        if (cards.length || !self.size) {
          return {
            cards: cards,
            document: doc,
            relaxed: false,
            totalCount: collectionTotalCount(doc)
          };
        }

        return fetchDocument(baseUrl).then(function(fallbackDoc) {
          return {
            cards: collectionCards(fallbackDoc),
            document: fallbackDoc,
            relaxed: true,
            totalCount: collectionTotalCount(fallbackDoc)
          };
        });
      }

      if (
        self.sizeMode === 'suit' ||
        self.sizeMode === 'hat' ||
        self.sizeMode === 'apparel' ||
        self.sizeMode === 'shoe'
      ) {
        if (!self.size) {
          return {
            cards: cards,
            document: doc,
            relaxed: false,
            totalCount:
              self.sizeMode === 'hat' ||
              self.sizeMode === 'apparel' ||
              self.sizeMode === 'shoe' ?
                collectionTotalCount(doc) :
                null
          };
        }

        return self.initialVerifiedResultBatch(doc, token).then(function(batch) {
          if (!batch || token !== self.requestToken) return null;
          if (batch.cards.length) {
            return {
              cards: batch.cards,
              nextPageUrl: batch.nextPageUrl,
              relaxed: false
            };
          }

          return fetchDocument(baseUrl).then(function(fallbackDoc) {
            return {
              cards: collectionCards(fallbackDoc),
              document: fallbackDoc,
              relaxed: true
            };
          });
        });
      }

      if (!self.size) return { cards: cards, relaxed: false };

      return self.availableCardsForSize(cards, limit).then(function(availableCards) {
        if (availableCards.length) {
          return { cards: availableCards, relaxed: false };
        }

        return fetchDocument(baseUrl).then(function(fallbackDoc) {
          return {
            cards: collectionCards(fallbackDoc),
            relaxed: true
          };
        });
      });
    }).then(function(result) {
      if (token !== self.requestToken || !result) return;
      self.renderResults(result, options.publishEvent !== false);
      self.completeInitialProgress(token);
      if (
        (
          self.sizeMode === 'suit' ||
          self.sizeMode === 'hat' ||
          self.sizeMode === 'apparel' ||
          self.sizeMode === 'shoe'
        ) &&
        self.size &&
        !result.relaxed &&
        verifiedCountRequest
      ) {
        verifiedCountRequest.then(function(totalCount) {
          if (token !== self.requestToken) return;
          var visibleCount = self.resultsGrid.querySelectorAll('[data-product-id]').length;
          if (!Number.isSafeInteger(totalCount) || totalCount < visibleCount) return;
          self.resultTotalCount = totalCount;
          self.updateResultsSummary();
        }).catch(function() {});
      }
    }).catch(function() {
      if (token !== self.requestToken) return;
      self.showRequestError();
    });
  };

  Finder.prototype.renderResults = function(result, publishEvent) {
    var limit = Number(this.root.getAttribute('data-results-limit')) || 8;
    var progressive =
      this.sizeMode === 'walking' ||
      this.sizeMode === 'suit' ||
      this.sizeMode === 'hat' ||
      this.sizeMode === 'apparel' ||
      this.sizeMode === 'shoe';
    var cards = progressive ? result.cards : result.cards.slice(0, limit);
    this.resetProgressiveResults();
    this.resultsGrid.innerHTML = '';

    if (
      (
        this.sizeMode === 'walking' ||
        this.sizeMode === 'hat' ||
        this.sizeMode === 'apparel' ||
        this.sizeMode === 'shoe'
      ) &&
      Number.isSafeInteger(result.totalCount) &&
      result.totalCount >= cards.length
    ) {
      this.resultTotalCount = result.totalCount;
    }

    this.verifyProgressiveResultSize =
      (
        this.sizeMode === 'suit' ||
        this.sizeMode === 'hat' ||
        this.sizeMode === 'apparel' ||
        this.sizeMode === 'shoe'
      ) &&
      Boolean(this.size) &&
      !result.relaxed;
    this.queueResultCards(cards);
    if (progressive) {
      this.nextResultPageUrl = typeof result.nextPageUrl === 'string' ?
        result.nextPageUrl :
        nextCollectionUrl(result.document);
      this.appendResultCards(RESULT_BATCH_SIZE);
      this.observeProgressiveResults();
    } else {
      this.appendResultCards(cards.length);
    }

    this.resultsNotice.hidden = !result.relaxed;
    this.resultsNotice.textContent = result.relaxed ?
      this.root.getAttribute('data-relaxed-message') :
      '';
    this.status.textContent = cards.length ? '' : this.root.getAttribute('data-zero-message');

    if (publishEvent) {
      publish('style_finder_results', {
        category: this.category,
        occasion: this.occasion,
        result_count: this.resultsGrid.querySelectorAll('[data-product-id]').length,
        relaxed_filter: result.relaxed ? 'size' : null
      });
    }
  };

  Finder.prototype.showRequestError = function() {
    if (this.step !== 4) {
      this.step = 4;
      this.pushHistory();
      this.render(true);
    }
    this.clearResults();
    this.status.textContent = this.root.getAttribute('data-error-message');
  };

  Finder.prototype.restore = function(state) {
    this.requestToken++;
    this.clearResults();
    this.categoryId = state.categoryId || '';
    this.category = state.category || '';
    this.occasion = state.occasion || '';
    this.destination = state.destination || '';
    this.sizeMode = state.sizeMode || 'all';
    this.size = state.size ? {
      name: state.size.name,
      value: state.size.value,
      values: Array.isArray(state.size.values) && state.size.values.length ?
        state.size.values :
        (state.size.value ? [state.size.value] : []),
      label: state.size.label
    } : null;
    this.step = Math.min(Math.max(Number(state.step) || 1, 1), 4);
    this.render(true);
    if (this.step === 3 && this.destination) this.loadSizes();
    if (this.step === 4 && this.destination) {
      this.showResults({ pushHistory: false, publishEvent: false });
    }
  };

  Finder.prototype.restart = function(pushState) {
    this.requestToken++;
    this.step = 1;
    this.categoryId = '';
    this.category = '';
    this.occasion = '';
    this.destination = '';
    this.size = null;
    this.baseDocument = null;
    this.clearResults();
    if (pushState) {
      publish('style_finder_restart', {});
      this.pushHistory();
    }
    this.render(true);
  };

  Finder.prototype.render = function(focus) {
    var self = this;
    var visibleStep = this.step === 4 ? 4 : this.step;

    this.panels.forEach(function(panel) {
      panel.hidden = Number(panel.getAttribute('data-style-step')) !== visibleStep;
    });

    this.categoryPanels.forEach(function(panel) {
      panel.hidden = panel.getAttribute('data-category-id') !== self.categoryId;
    });

    this.progress.forEach(function(item) {
      var number = Number(item.getAttribute('data-style-progress'));
      item.removeAttribute('aria-current');
      item.setAttribute('data-complete', number < self.step ? 'true' : 'false');
      if (number === self.step) item.setAttribute('aria-current', 'step');
    });

    this.controls.hidden = this.step === 1;
    this.backButton.hidden = this.step === 1;

    if (this.step === 2) this.prefetchVisibleOccasions();

    if (focus) {
      var heading = this.root.querySelector('[data-style-step="' + visibleStep + '"] [data-style-focus]');
      if (heading) heading.focus({ preventScroll: false });
    }
  };

  function initialize(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);
    root.classList.add('style-finder--ready');
    new Finder(root);
  }

  function initializeWithin(scope) {
    if (scope.matches && scope.matches('[data-style-finder]')) initialize(scope);
    scope.querySelectorAll('[data-style-finder]').forEach(initialize);
  }

  window.__suitsAndMoreStyleFinder = { initialize: initializeWithin };
  initializeWithin(document);
  document.addEventListener('shopify:section:load', function(event) {
    initializeWithin(event.target);
  });
})();
